import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { ProductTypeCompartments, productTypeStorageKey } from '..';

export class ProductTypeListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.PricebooksSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(productTypeStorageKey)
    private readonly cache: DataCache<ProductTypeCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('productType');
        } else {
          this.cache.reset('productType');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}

export class PaidByListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.PricebooksSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(productTypeStorageKey)
    private readonly cache: DataCache<ProductTypeCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('paidBy');
        } else {
          this.cache.reset('paidBy');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
